import { useContext, useEffect, useState } from 'react';
import classes from './styles.module.scss';
import Layout from '../../../components/Layout/user/Layout';
import { GlobalContext, GlobalStore } from '../../../context/provider';
import { DeviceContext } from '../../../deviceType';
import ProductCard from './productCard';
import {
  addProductView,
  getSingleProduct,
} from '../../../context/actions/products';
import { GET_SINGLE_PRODUCT_ERROR } from '../../../context/actions/types';
import RecoCard from './reccomendations';
import ProductDetailSkeleton from '../../../components/skeletons/product-details-page';
import { storeSchema } from '../../../types/store';
import { ProductType } from '../../../types/product';
import ErrorToast from '../../../components/error_toast';
import { useLocation } from 'react-router';
import WhatsappFAB from '../../../components/WhatsappFAB';

const ProductDetails = () => {
  const size = useContext(DeviceContext);
  const location = useLocation();
  const { productState, productDispatch } =
    useContext<GlobalStore>(GlobalContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [product, setProduct] = useState<ProductType>({} as ProductType);
  const [store, setStore] = useState<storeSchema>({} as storeSchema);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setLoading(true);
    const id = window.location.search.split('=')[1];
    if (id) fetchProduct({ id: Number(id || '0') });
  }, [location]);

  useEffect(() => {
    const id = window.location.search.split('=')[1];
    if (
      productState.getSingleProduct &&
      productState.getSingleProduct?.id === Number(id)
    ) {
      const res = productState.getSingleProduct;
      const { store, tags } = res;
      let _tags = tags ? tags.split(', ').filter((a) => a !== '{}') : [];
      setProduct({ ...res, tags: _tags });
      setStore(store!);
      addView(res?.id!);
      setLoading(false);
    }
    if (productState?.getSingleProductError) {
      setIsErrorOpen(true);
      setErrorMessage(
        productState.getSingleProductError!?.response!?.data!?.message
          ? productState.getSingleProductError!?.response!?.data!?.message
          : productState.getSingleProductError!?.message
      );
      productDispatch({ type: GET_SINGLE_PRODUCT_ERROR, payload: null });
    }
  }, [productState.getSingleProduct, productState.getSingleProductError]);

  async function fetchProduct(e: { id: number }) {
    const state = productState.getSingleProduct;
    if (state && state?.id === e?.id) {
      setStore(state?.store!);
      const { tags, ...rest } = state;
      let _tags = tags ? tags.split(', ').filter((a) => a !== '{}') : [];
      return setProduct({ ...rest, tags: _tags });
    }
    await getSingleProduct(e.id)(productDispatch);
  }
  async function addView(productId: number) {
    await addProductView({ productId })(productDispatch);
  }

  return (
    <Layout
      seoData={{
        title: `${product.name} - ${product.store?.name} | Bazaarcheap.com`,
        description: product.details,
        url: window.location.href,
        ogImage: product?.images?.[0],
        productName: product.name,
        productPrice: product.price,
        productCategory: product.type,
        productImage:product?.images?.[0],
      }}
     whatsappContact={store.whatsappContact}
    >
      <ErrorToast
        message={errorMessage}
        type={'error'}
        isOpen={isErrorOpen}
        onClose={() => {
          setIsErrorOpen(false);
        }}
      />

      {loading === false ? (
        <div className="w-full h-auto flex flex-col items-center md:px-[10%] py-2 bg-white">
          <div className={' m-0 p-0 size-full'}>
            <ProductCard data={product} disableWishlist={false} />
          </div>
          <div
            className={
              'p-4 md:px-6 rounded-2xl w-full h-auto bg-background mt-6 mx-2'
            }
          >
            <RecoCard ref_product={product} />
          </div>
        </div>
      ) : (
        <div className={classes.loading + ' bg-white'}>
          <ProductDetailSkeleton />
        </div>
      )}
    </Layout>
  );
};

export default ProductDetails;
